/* AFIQ /collections/bundles (port of the inline script in site/bundles.html).
   Elite leads as the one recommended set, with Flag 5v5 and Basics as add-on toggles; the smaller sets stay
   listed quietly and link to their own pages. Every price = AFIQ_UI.priceDecks (the cheapest real route:
   Play Fast Max costs more than three decks on the ladder, so the Vol 1–3 set prices as three decks).
   Loaded by two sections; the guard makes it run once. */
(function () {
  'use strict';
  if (window.__afiqBundles) return;
  window.__afiqBundles = true;
  if (!window.AFIQ_UI) return;
  var U = window.AFIQ_UI, P = U.P, $ = U.$, esc = U.esc, I = U.I, priceDecks = U.priceDecks;
  var ELITE = ['v1', 'v2', 'v3', 'v4'];
  if (!ELITE.every(function (d) { return P[d]; })) return;
  var B = [
    { key: 'starter', title: 'Play Fast bundle', decks: ['v1', 'v2'] },
    { key: 'elite', title: 'The full system', decks: ELITE, top: true },
    { key: 'core', title: 'Vol 1–3 set', decks: ['v1', 'v2', 'v3'] }
  ];

  function fillStacks(root) {
    root.querySelectorAll('.mini-stack[data-decks]').forEach(function (el) {
      var d = el.dataset.decks.split(',').filter(function (x) { return P[x]; });
      if (d.length) el.outerHTML = U.stack(d, null, !!el.closest('.bhero-art'));
    });
  }

  /* ---------- Elite card + add-ons + also rows ---------- */
  function main(root) {
    var box = root.querySelector('[data-afiq-bundles]');
    if (!box) return;
    fillStacks(box);
    var eq = priceDecks(ELITE), add = [];
    var list = box.querySelector('[data-blist]');
    if (list) list.innerHTML = ELITE.map(function (d) { return '<li>' + I.check + esc(P[d].label) + ': ' + esc(P[d].title) + '</li>'; }).join('');
    var adds = box.querySelector('[data-adds]');
    if (adds) adds.insertAdjacentHTML('beforeend', ['fl5', 'basics'].filter(function (id) { return P[id] && P[id].available !== false; }).map(function (id) {
      var x = P[id];
      return '<button type="button" class="bx-add" data-toggle="' + id + '" aria-pressed="false"><span class="box">' + I.plus + '</span><img src="' + esc(x.cutout) + '" alt="" loading="lazy" width="40" height="58"><span><b>' +
        (id === 'fl5' ? 'Add Flag Football IQ 5v5' : 'Add Football Basics') + '</b><small>' + esc(x.tag) + '</small></span></button>';
    }).join(''));
    box.querySelectorAll('[data-price-decks]').forEach(function (el) {
      var d = el.dataset.priceDecks.split(','); if (d.every(function (x) { return P[x]; })) el.textContent = $(priceDecks(d).total);
    });
    var diff = box.querySelector('[data-diff]');
    if (diff) { diff.textContent = 'The full system is only ' + $(eq.total - priceDecks(['v1', 'v2', 'v3']).total) + ' more than Volumes 1–3.'; diff.hidden = false; }

    var tot = box.querySelector('[data-btot]'), full = box.querySelector('[data-bfull]'), save = box.querySelector('[data-bsave]'), btn = box.querySelector('[data-badd]');
    function upd() {
      var ids = ELITE.concat(add), q = priceDecks(ids);
      if (tot) tot.textContent = $(q.total);
      if (full) full.textContent = q.save > 0 ? $(q.full) : '';
      if (save) { save.textContent = 'Save ' + $(q.save); save.hidden = !(q.save > 0); }
      box.querySelectorAll('.bx-add').forEach(function (b) {
        var on = add.indexOf(b.dataset.toggle) > -1;
        b.classList.toggle('on', on); b.querySelector('.box').innerHTML = on ? I.check : I.plus; b.setAttribute('aria-pressed', on);
      });
      if (btn) btn.innerHTML = I.cart + 'Add ' + ids.length + ' decks · ' + $(q.total);
    }
    box.addEventListener('click', function (ev) {
      var t = ev.target.closest('[data-toggle]'); if (!t) return;
      var id = t.dataset.toggle, i = add.indexOf(id), on = i < 0;
      if (on) add.push(id); else add.splice(i, 1);
      upd();
      U.track('afiq_bundles_addon', { addon: id, on: on, decks: ELITE.length + add.length, value: +(priceDecks(ELITE.concat(add)).total / 100).toFixed(2) });
    });
    if (btn) btn.addEventListener('click', function (ev) { U.addToCart(U.cartItems(ELITE.concat(add), 'bundles-elite'), 'bundles-elite', ev.currentTarget); });
    upd();
  }

  /* ---------- comparison table ---------- */
  function table(root) {
    var t = root.querySelector('[data-ctable]');
    if (!t) return;
    var cols = [B[0], B[2], B[1]];
    var rows = ELITE.map(function (d) {
      return '<tr><td><b>' + esc(P[d].label) + '</b> · ' + esc(P[d].title) + '</td>' + cols.map(function (b) { return b.decks.indexOf(d) > -1 ? '<td>' + I.check + '</td>' : '<td class="no">—</td>'; }).join('') + '</tr>';
    }).join('');
    var q = cols.map(function (b) { return priceDecks(b.decks); });
    t.innerHTML = '<thead><tr><th></th>' + cols.map(function (b) { return '<th class="' + (b.top ? 'top' : '') + '">' + b.title + '</th>'; }).join('') + '</tr></thead><tbody>' + rows +
      '<tr><td>Cards</td>' + cols.map(function (b) { return '<td>' + b.decks.reduce(function (s, d) { return s + (P[d].cards || 54); }, 0) + '</td>'; }).join('') + '</tr>' +
      '<tr><td>Per deck</td>' + q.map(function (x, i) { return '<td>' + $(Math.round(x.total / cols[i].decks.length)) + '</td>'; }).join('') + '</tr>' +
      '<tr><td>You save</td>' + q.map(function (x) { return '<td>' + $(x.save) + '</td>'; }).join('') + '</tr>' +
      '<tr><td>Price</td>' + q.map(function (x) { return '<td>' + $(x.total) + '</td>'; }).join('') + '</tr></tbody>';
  }

  function init(root) { main(root); table(root); }
  init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
